
import React from 'react';
import { PageContainer } from '@/components/ui/page-container';
import MobileAiAssistanceSection from './MobileAiAssistanceSection';

const MobileAiAssistance = () => {
  return (
    <PageContainer
      title="Assistant IA médical"
      variant="ai"
      intensity="high"
      className="py-4 px-1"
    >
      <MobileAiAssistanceSection />
    </PageContainer>
  );
};

export default MobileAiAssistance;
